document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(
    ".announcement-bar__message, .announcement__text, .announcement-text"
  );

  if (!items.length) return;

  let index = 0;

  items.forEach((item, i) => {
    item.style.display = i === 0 ? "block" : "none";
  });

  setInterval(() => {
    items[index].style.display = "none";
    index = (index + 1) % items.length;
    items[index].style.display = "block";
  }, 3000);
});
